import Caption, { CaptionProps } from "components/Typography/Caption"
import { memo, useMemo } from "react"
import styled from "styled-components"

const InfoCardContainer = styled.div`
  background: ${(props) => props.theme.palette.white};
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  box-shadow: 0px 2px 6px 0px #0d0a2c14;
  padding: 12px 20px;
  max-width: 340px;
  width: 100%;
`

const QuantityContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
`

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  align-items: center;
  width: fit-content;
`

interface BalanceCardProps {
  eventType: App.EventTypesUsageInfo
}

const BalanceCard = (props: BalanceCardProps) => {
  const { eventType } = props

  const { label, quota, usedBalance } = eventType

  const balance = useMemo(() => {
    if (quota === null) return usedBalance

    const value = quota - usedBalance

    return value
  }, [quota, usedBalance])

  const quantityLabel = useMemo<{ label: string; color: CaptionProps["color"] }>(() => {
    const quotaValue = quota == null

    const isPositive = quotaValue ? balance <= 0 : balance >= 0

    return {
      label: isPositive ? "Disponível" : "A pagar",
      color: isPositive ? "success" : "error"
    }
  }, [balance, quota])

  const formattedValue = useMemo(() => {
    const valueStr = Math.abs(balance).toString()
    const decimalPart = valueStr.split(".")[1]

    if (decimalPart && decimalPart.length > 2) {
      return balance.toFixed(2)
    }

    return valueStr
  }, [balance])

  return (
    <InfoCardContainer>
      <ContentContainer>
        <Caption color="gray-dark" weight="semi-bold" size="large">
          Tipo de Evento
        </Caption>
        <Caption color="gray-dark" weight="semi-bold" size="medium">
          {label}
        </Caption>
      </ContentContainer>
      <ContentContainer>
        <Caption color="gray-dark" weight="semi-bold" size="large">
          Quantidade
        </Caption>
        <QuantityContainer>
          <Caption color="gray-dark" weight="semi-bold" size="medium">
            {formattedValue}
          </Caption>
          <Caption color={quantityLabel.color} weight="semi-bold" size="medium">
            {quantityLabel.label}
          </Caption>
        </QuantityContainer>
      </ContentContainer>
    </InfoCardContainer>
  )
}

export default memo(BalanceCard)
